export const REQUIRED_FIELDS = [
  'domain',
  'consent',
  'contactAdmin',
  'contactBilling',
  'contactRegistrant',
  'contactTech',
]

export const US_ENTITY_TYPE_ENUMS = {
  PERSONAL: ['CITIZEN', 'PERMANENT_RESIDENT', 'PRIMARY_DOMICILE'],
  BUSINESS: ['INCORPORATED', 'FOREIGN_BUSINESS', 'FOREIGN_OFFICE'],
}

export const CA_LANGUAGE_ENUMS = {
  EN: 'English',
  FR: 'French',
}

export const CA_ENTITY_TYPES_REQUIRE_ORGANIZATION = [
  'ASSOCIATION',
  'CORPORATION',
  'EDUCATIONAL',
  'GOVERNMENT',
  'HOSPITAL',
  'INDIAN_BAND',
  'LIBRARY_ARCHIVE_MUSEUM',
  'MARK_REGISTERED',
  'MARK_TRADE',
  'PARTNERSHIP',
  'POLITICAL_PARTY',
  'TRUST',
  'UNION',
]

export const CA_ENTITY_TYPES_NOT_ORGANIZATIONAL = [
  'ABORIGINAL',
  'CITIZEN',
  'LEGAL_REPRESENTATIVE',
  'RESIDENT_PERMANENT',
]
